import { render, staticRenderFns } from "./EnumType.vue?vue&type=template&id=708d1570&scoped=true&"
import script from "./EnumType.vue?vue&type=script&lang=ts&"
export * from "./EnumType.vue?vue&type=script&lang=ts&"
import style0 from "./EnumType.vue?vue&type=style&index=0&id=708d1570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708d1570",
  null
  
)

export default component.exports